<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">Image URL Generator</h5>
      <br />
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <!-- <b-button variant="primary" @click="showModalFormImageURLGenerator('create', '')">
            <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
          </b-button> -->
          <router-link :to="{name: 'CreateImageURLGenerator'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <br />
      <!-- <section v-if="table_error">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section> -->
      <b-table
        responsive
        show-empty
        hover
        ref="ImageURLGenerator"
        :items="getDataImageURLGenerator"
        :fields="types"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(title)="{ item }">
          <p class="mb-0">{{item.title}}</p>
        </template>
        <template v-slot:cell(image)="{ item }">
          <b-img :src="item.image" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(image_url)="{ item }">
          <p class="mb-0">{{item.image}}</p>
        </template>
        <template v-slot:cell(action)="{item}">
          <b-row class="row">
            <div class="col-md-4">
              <b-link v-b-tooltip.hover title="Copy URL" class="text-dark" @click="copyURL(item.image)">
                <img src="@/assets/ic-view-detail.svg" alt />
              </b-link>
            </div>
            <div class="col-md-4">
              <router-link
                v-b-tooltip.hover
                title="Edit"
                :to="{name: 'EditImageURLGenerator', params: {id: item.id}}"
                class="text-dark"
              >
                <img src="@/assets/ic-edit.svg" alt />
              </router-link>
            </div>
            <div class="col-md-4">
              <b-link v-if="!item.default_banner" v-b-tooltip.hover title="Delete" class="text-dark" @click="deleteImageURLGenerator(item.id, item.title)">
                <img src="@/assets/rectangle.svg" alt />
              </b-link>
            </div>
          </b-row>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" align="left" class="mx-auto px-0">
          <div v-if="totalRows == 0 || totalRows == null">
            Showing 0 Records
          </div>
          <div v-else>
            Showing {{ fromPage[currentPage - 1] }} to
            {{ toPage[currentPage - 1] }} of {{ totalRows }} Records
          </div>
        </b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading_image_url_generator: false,
      image_url_generators: [],
      types: [
        {
          key: "title",
          label: "Title",
          sortable: false,
          class: "text-left w-25"
        },
        {
          key: "image",
          label: "Image",
          sortable: false,
          class: "text-left w-15"
        },
        {
          key: "image_url",
          label: "Image URL",
          sortable: false,
          class: "text-left"
        },
        { key: "action", label: "Action", class: "text-left w-10" }
      ],
      fromPage: [],
      toPage: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: true,
      sortDirection: "asc",
      filter: ""
    } 
  },
  methods: {
    getDataImageURLGenerator(ctx, callback) {
      this.loading_image_url_generator = true;
      const vm = this;
      const formData = new FormData();
      formData.append("search_param", ctx.filter);
      formData.append("limit", ctx.perPage);
      formData.append("page", ctx.currentPage);
      formData.append("sort_by", ctx.sortBy);
      formData.append("is_sort_asc", false);
      this.$store
        .dispatch("ImageURLGeneratorModule/getImageURLGeneratorWithPaging", formData)
        .then(response => {
          vm.totalRows = response.data.data.total_record;
          var from = [];
          var to = [];
          var sum = 0;
          for (let i = 1; i <= vm.currentPage; i++) {
            sum = i * vm.perPage;
            if (vm.totalRows <= sum) {
              from.push(sum - vm.perPage + 1);
              to.push(vm.totalRows - sum + sum);
            } else {
              from.push(sum - vm.perPage + 1);
              to.push(sum);
            }
          }
          this.fromPage = from;
          this.toPage = to;
          this.image_url_generators = response.data.data.results || [];
          callback(response.data.data.results || []);
          this.loading_image_url_generator = false;
        })
        .catch(error => {
          this.$swal({
            type: "error",
            title: "Error!",
            text: error.response ? error.response.data.message : "Failed get imgae url generator",
            showConfirmButton: false,
            timer: 1500,
          });
          this.loading_image_url_generator = false;
          callback([]);
        });
      return null;
    },
    deleteImageURLGenerator(id, title) {
      this.$swal({
        text: `Are you sure want to delete ${title}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#6051a2",
        cancelButtonColor: "#f8f9fc",
        cancelButtonClass: "text-primary",
        confirmButtonText: "Delete",
        scrollbarPadding: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("ImageURLGeneratorModule/deleteImageURLGenerator", id)
            .then((response) => {
              this.$swal("Deleted!", "Your data has been deleted.", "success");
              this.$refs.ImageURLGenerator.refresh();
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response ? error.response.data.message : "Failed to delete",
                showConfirmButton: false,
                scrollbarPadding: false,
                timer: 1500,
              });
            });
        }
      });
    },
    copyURL(imageURL) {
      let dummy = document.createElement("input");

      document.body.appendChild(dummy);
      dummy.value = imageURL;
      dummy.select();
      document.execCommand("copy");
      this.$swal({
        title: "Image URL copied",
        type: "success",
        showConfirmButton: false,
        timer: 1000,
      });
      document.body.removeChild(dummy);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  }
};
</script>